import { Ticket, TicketStatus, TicketStatusLabels } from '@insta-club/models';
import { formatDate } from '@insta-club/utilities';
import Link from 'next/link';
import { ChevronIcon } from 'src/libs/components/icons';
import CalenderIcon from 'src/libs/components/icons/calender';

export const TicketStatusColors: Record<TicketStatus, string> = {
    [TicketStatus.Closed]: 'bg-gray-300 text-gray-800',
    [TicketStatus.Answered]: 'bg-blue-100 text-blue-600',
    [TicketStatus.Waiting]: 'bg-primary-50 text-primary-700',
    [TicketStatus.Pending]: 'bg-primary-50 text-primary-700'
};

function TicketItem({ item }: { item: Ticket }) {
    return (
        <>
            <Link href={`/support/tickets/${item.id}`} className='block'>
                <div className='shadow-main space-y-2 rounded-xl bg-white p-4'>
                    <div className='flex items-center justify-between'>
                        <div>
                            <span className='text-sm font-semibold text-gray-700'>{item.uid}#</span>
                            {' - '}
                            <span className='text-sm font-semibold text-gray-700'>{item.category?.name}</span>
                        </div>
                        <div
                            className={`flex items-center rounded-sm px-2 py-0.5 text-sm font-normal ${
                                TicketStatusColors[item.status] || 'bg-gray-300 text-gray-800'
                            }`}
                        >
                            {TicketStatusLabels[item.status] || item.status}
                        </div>
                    </div>
                    <h6 className='text-base font-semibold text-gray-800'>{item.title}</h6>
                    <div className='flex items-center justify-between'>
                        <div className='flex items-center justify-end space-x-1'>
                            <CalenderIcon className='text-gray-500' />
                            <span className='text-xs font-normal text-gray-500'>
                                {item.created_at.dayOfWeek} {formatDate(item.created_at, '%d %m %y')}
                            </span>
                        </div>

                        <div className='flex items-center space-x-1'>
                            <span className='text-sm font-semibold text-gray-800'>جزئیات</span>
                            <ChevronIcon width={14} height={14} />
                        </div>
                    </div>
                </div>
            </Link>
        </>
    );
}

export default TicketItem;

